import {RMFlightWrapper} from "../../../types";
import { useReceiveMessage } from "../../../useReceivedMessage";
import { useEffect, useState } from "react";
import { format } from "date-fns";

function SearchFlightsResultModalStatus({ result }: { result: RMFlightWrapper }) {
  const [selected, setSelected] = useState<number>(1);
  const [flights, setFlights] = useState<any[]>();
  const [url, setUrl] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);

  const iframeRef = useReceiveMessage(url);

  const onIframeLoad = () => {
    setLoading(false);
  };

  const handleChange = (event) => {
    setSelected(event.target.value);
    setLoading(true);
  };

  useEffect(() => {
    if (selected === 1) {
      setUrl(
        `https://tracker.flightview.com/FVAccess3/tools/tracker/tracker.asp?accCustId=OAGFlights&trId=10001&trInit=1&trQtype=SingleFlight&trAl=${
          result.operatedBy
        }&trAcid=${result.flightNo}&trDate=${convertToDate(
          result.departureDate
        )}`
      );
    } else if (selected === 2) {
      setUrl(
        `https://tracker.flightview.com/FVAccess3/tools/tracker/tracker.asp?accCustId=OAGFlights&trId=10001&trInit=1&trQtype=SingleFlight&trAl=${
          result.connxLeg2OperatedBy
        }&trAcid=${result.connxLeg2FlightNo}&trDate=${convertToDate(
          result.connxLeg2DepartureDate
        )}`
      );
    } else if (selected === 3) {
      setUrl(
        `https://tracker.flightview.com/FVAccess3/tools/tracker/tracker.asp?accCustId=OAGFlights&trId=10001&trInit=1&trQtype=SingleFlight&trAl=${
          result.connxLeg3OperatedBy
        }&trAcid=${result.connxLeg3FlightNo}&trDate=${convertToDate(
          result.connxLeg3DepartureDate
        )}`
      );
    }
  }, [selected, result]);

  useEffect(() => {
    const values = [];
    values.push({
      value: 1,
      label: `#1 - ${result.airline} - ${result.operatedBy} ${result.flightNo}`,
    });
    if (result.connxLeg2OperatedBy !== null) {
      values.push({
        value: 2,
        label: `#2 - ${result.connxLeg2Airline} - ${result.connxLeg2OperatedBy} ${result.connxLeg2FlightNo}`,
      });
    }
    if (result.connxLeg3OperatedBy !== null) {
      values.push({
        value: 3,
        label: `#3 - ${result.connxLeg3Airline} - ${result.connxLeg2OperatedBy} ${result.connxLeg3FlightNo}`,
      });
    }
    setFlights(values);
    setSelected(1);
  }, [result]);

  if (!url) {
    return null;
  }

  return (
    <>
      {flights.length > 1 && (
        <div className="columns">
          <div className="column" />
          <div className="column">
            <select className="select" value={selected} onChange={handleChange}>
              {flights.map((flight, i) => (
                <option key={i} value={flight.value}>{flight.label}</option>
              ))}
            </select>
          </div>
          <div className="column" />
        </div>
      )}
      {loading && (
        <div className="loader-wrapper">
          <div className="loader is-loading" />
        </div>
      )}
      <iframe
        key={selected}
        ref={iframeRef}
        title="Flight Status"
        onLoad={onIframeLoad}
        style={{
          width: "100%",
          minHeight: "800px",
        }}
        src={url}
      />
    </>
  );
}

function convertToDate(timestamp: number): string {
  //TODO: check with time zones if the date is correct
  return format(new Date(timestamp), "yyyyMMdd");
}

export default SearchFlightsResultModalStatus;
